"use strict";const o=require("./setPrototypeOf-56fae5cd.js");function r(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,o._setPrototypeOf(t,e)}exports._inheritsLoose=r;
